/* eslint-disable jsx-a11y/label-has-for */
import React, { useState, useEffect, useContext } from 'react';
import { PropTypes } from 'prop-types';
// import { PostInfoContext } from '../../../../utils/PostInfoProvider';


const SimpleTag = ({
  activeLanguage, handlerSetComponents, components, languages, id, reusableComponent, reusableComponentSlugname, slider,
}) => {
  const initialState = {
    type: 'SimpleTag',
    text: {
      es: '',
      en: '',
      ca: '',
      pt: '',
    },
    category: '',
  };

  const [index, setIndex] = useState();
  const [state, setState] = useState(initialState);

  // const context = useContext(PostInfoContext);

  const inputHandler = (e) => {
    const { value, name, lang } = e.target;

    const { component } = components[index];

    const comp = {
      ...component,
      [name]: {
        ...component[name],
        [lang.toLowerCase()]: value,
      },
      category: value.toLowerCase(),
    };

    setState(comp);

    const componentObj = {
      id,
      component: comp,
    };

    handlerSetComponents(componentObj, index);
  };

  useEffect(() => {
    const componentIndex = components.findIndex(obj => obj.id === id);

    const { component } = components[componentIndex];
    if (reusableComponent) {
      setState(reusableComponent);
      if (!component) handlerSetComponents({ component: { key: reusableComponentSlugname } }, componentIndex);
    } else {
      setIndex(componentIndex);
      if (component) {
        const comp = {
          ...component,
        };
        setState(comp);
      } else {
        const comp = {
          ...state,
        };
        setState(comp);
        const componentObj = {
          id,
          component: comp,
        };
        handlerSetComponents(componentObj, componentIndex);
      }
    }
  }, [components]);

  return (
    <>
      {languages.map(lang => (
        <div key={lang} className={`w-full ${activeLanguage.toLowerCase() === lang.toLowerCase() ? 'block' : 'hidden'} ${slider ? 'p-1' : 'p-4'}`}>
          <input className={`font-americaMonoRegular bg-white outline-none w-full ${slider ? 'pl-8 p-2px' : ' p-2 pl-12'}`} onChange={inputHandler} name="text" lang={lang} type="text" value={state.text && state.text[lang.toLowerCase()]} readOnly={reusableComponent && reusableComponent} />
        </div>
      ))}
    </>
  );
};

SimpleTag.propTypes = {
  activeLanguage: PropTypes.string.isRequired,
  handlerSetComponents: PropTypes.func.isRequired,
  components: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  id: PropTypes.string.isRequired,
  languages: PropTypes.arrayOf(PropTypes.string).isRequired,
  reusableComponent: PropTypes.shape(),
  slider: PropTypes.bool,
};
SimpleTag.defaultProps = {
  reusableComponent: null,
  slider: false,
};

export default SimpleTag;
